export const DELINQUENCY_FOLLOW_UP_STAGES = [
  'FUP 1',
  'FUP 2',
  'Em negociação',
  'FUP negociação',
  'Link de pagamento 1',
  'Link de pagamento 2',
  'Link de pagamento 3',
  'Aviso de cancelamento',
  'Reativada',
] as const;

export type DelinquencyFollowUpStage = (typeof DELINQUENCY_FOLLOW_UP_STAGES)[number];

export const DELINQUENCY_FOLLOW_UP_STAGE_OPTIONS = DELINQUENCY_FOLLOW_UP_STAGES.map((stage) => ({
  value: stage,
  label: stage,
}));

export const isDelinquencyFollowUpStage = (
  value: string,
): value is DelinquencyFollowUpStage => (
  (DELINQUENCY_FOLLOW_UP_STAGES as readonly string[]).includes(value)
);
